import { render, staticRenderFns } from "./Form-new-password.vue?vue&type=template&id=2c13f864&scoped=true"
import script from "./Form-new-password.vue?vue&type=script&lang=js"
export * from "./Form-new-password.vue?vue&type=script&lang=js"
import style0 from "./Form-new-password.vue?vue&type=style&index=0&id=2c13f864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13f864",
  null
  
)

export default component.exports